let sharedFilterTree = [
  {
    name: "Luftsicherheit", tags: ["Luftsicherheit"], key: "LS", children: [
      {
        name: "Kapitel 11.2.5 (Sicherheitsbeauftragter)", key: "LS-1125",
        tags: ["Luftsicherheit", "Sicherheitsbeauftragter"],
        children: [
          {
            name: "Grundschulung",
            key: "LS-1125-G",
            tags: ["Luftsicherheit", "Sicherheitsbeauftragter",
              "LuftsicherheitGrundschulung"],
            children: [
              {
                name: "Web-Seminar",
                key: "LS-1125-G-W",
                tags: ["Luftsicherheit", "Sicherheitsbeauftragter",
                  "LuftsicherheitGrundschulung", "LuftsicherheitWeb"],
                children: [],
              },
              {
                name: "Präsenz",
                key: "LS-1125-G-P",
                tags: ["Luftsicherheit", "Sicherheitsbeauftragter",
                  "LuftsicherheitGrundschulung", "LuftsicherheitPräsenz"],
                children: [],
              }
            ]
          },
          {
            name: "Auffrischungsschulung",
            key: "LS-11-A",
            tags: ["Luftsicherheit", "Sicherheitsbeauftragter",
              "LuftsicherheitAuffrischung"],
            children: [],
          }
        ]
      },
      {
        name: "Kapitel 11.2.3.9",
        tags: ["Luftsicherheit", "Kapitel11239"],
        key: "LS-11239",
        children: [],
      }
    ]
  },
  {
    name: "Gefahrgut", key: "G", tags: ["Gefahrgut"], children: [
      {
        name: "Straßenverkehr",
        key: "G-S",
        tags: ["Gefahrgut", "Straßenverkehr"],
        children: [],
      },
      {
        name: "Luftverkehr",
        key: "G-L",
        tags: ["Gefahrgut", "Luftverkehr"],
        children: [
          {
            name: "Modul A (Versender)",
            key: "G-L-A",
            tags: ["Gefahrgut", "Luftverkehr", "ModulA"],
            children: [
              {
                name: "Grundschulung",
                key: "G-L-A-G",
                tags: ["Gefahrgut", "Luftverkehr", "ModulA",
                  "ModulAGrundschulung"],
                children: [
                  {
                    name: "Web-Seminar",
                    key: "G-L-A-G-W",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulA",
                      "ModulAGrundschulung", "ModulAGrundschulungWeb"],
                    children: [],
                  },
                  {
                    name: "Präsenz",
                    key: "G-L-A-G-P",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulA",
                      "ModulAGrundschulung", "ModulAGrundschulungPräsenz"],
                    children: [],
                  }
                ]
              },
              {
                name: "Auffrischungsschulung",
                key: "G-L-A-A",
                tags: ["Gefahrgut", "Luftverkehr", "ModulA",
                  "ModulAAuffrischungsschulung"],
                children: [
                  {
                    name: "Web-Seminar",
                    key: "G-L-A-A-W",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulA",
                      "ModulAAuffrischungsschulung",
                      "ModulAAuffrischungsschulungWeb"],
                    children: [],
                  },
                  {
                    name: "Präsenz",
                    key: "G-L-A-A-P",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulA",
                      "ModulAAuffrischungsschulung",
                      "ModulAAuffrischungsschulungPräsenz"], children: [],
                  }
                ]
              }
            ]
          },
          {
            name: "Modul B (Verpacker)",
            key: "G-L-B",
            tags: ["Gefahrgut", "Luftverkehr", "ModulB"],
            children: [
              {
                name: "Grundschulung",
                key: "G-L-B-G",
                tags: ["Gefahrgut", "Luftverkehr", "ModulB",
                  "ModulBGrundschulung"],
                children: [
                  {
                    name: "Web-Seminar",
                    key: "G-L-B-G-W",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulB",
                      "ModulBGrundschulung", "ModulBGrundschulungWeb"],
                    children: [],
                  },
                  {
                    name: "Präsenz",
                    key: "G-L-B-G-P",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulB",
                      "ModulBGrundschulung", "ModulBGrundschulungPräsenz"],
                    children: [],
                  }
                ]
              },
              {
                name: "Auffrischungsschulung",
                key: "G-L-B-A",
                tags: ["Gefahrgut", "Luftverkehr", "ModulB",
                  "ModulBAuffrischungsschulung"],
                children: [
                  {
                    name: "Web-Seminar",
                    key: "G-L-B-A-W",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulB",
                      "ModulBAuffrischungsschulung",
                      "ModulBAuffrischungsschulungWeb"],
                    children: [],
                  },
                  {
                    name: "Präsenz",
                    key: "G-L-B-A-P",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulB",
                      "ModulBAuffrischungsschulung",
                      "ModulBAuffrischungsschulungPräsenz"],
                    children: [],
                  }
                ]
              }
            ]
          },
          {
            name: "Modul C (Spediteur Abwicklung DGR)",
            key: "G-L-C",
            tags: ["Gefahrgut", "Luftverkehr", "ModulC"],
            children: [
              {
                name: "Grundschulung",
                key: "G-L-C-G",
                tags: ["Gefahrgut", "Luftverkehr", "ModulC",
                  "ModulCGrundschulung"],
                children: [],
              },
              {
                name: "Auffrischungsschulung",
                key: "G-L-C-A",
                tags: ["Gefahrgut", "Luftverkehr", "ModulC",
                  "ModulCAuffrischungsschulung"],
                children: [
                  {
                    name: "Web-Seminar",
                    key: "G-L-C-A-W",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulC",
                      "ModulCAuffrischungsschulung",
                      "ModulCAuffrischungsschulungWeb"],
                    children: [],
                  },
                  {
                    name: "Präsenz",
                    key: "G-L-C-A-P",
                    tags: ["Gefahrgut", "Luftverkehr", "ModulC",
                      "ModulCAuffrischungsschulung",
                      "ModulCAuffrischungsschulungPräsenz"],
                    children: [],
                  }
                ]
              }
            ]
          },
          {
            name: "Modul D+E (Spediteur - Abwicklung von Luftfracht, die keine gefährlichen Güter enthält und Speditionsumschlag)",
            key: "G-L-D",
            tags: ["Gefahrgut", "Luftverkehr", "ModulDE"],
            children: []
          },
          {
            name: "Modul G+H(Airline - Abwicklung von Nicht-Gefahrgutsendungen und Frachtumschlag)",
            key: "G-L-G",
            tags: ["Gefahrgut", "Luftverkehr", "ModulGH"],
            children: []
          },
          {
            name: "Modul O (Sicherheitspersonal für Passagier- und Gepäckkontrolle)",
            key: "G-L-O",
            tags: ["Gefahrgut", "Luftverkehr", "ModulO"],
            children: []
          },
          {
            name: "Modul I+R (Personal Passagierabfertigung)",
            key: "G-L-IR",
            tags: ["Gefahrgut", "Luftverkehr", "ModulIR"],
            children: []
          }
        ]
      }
    ]
  },
  {name: "ULD & BUP 500+", key: "ULD", tags: ["ULD&BUP"], children: [],},
  {
    name: "Ladungssicherung",
    key: "Ladungssicherung",
    tags: ["Ladungssicherung&BUP"],
    children: [],
  },
  {
    name: "Flurförderfahrzeuge",
    key: "Flur",
    tags: ["Flurförderfahrzeuge"],
    children: [],
  }
];
export default sharedFilterTree;
